<template>
    <div v-if="detailItem && detailItem.id">
      <div class="bg-light my-5 p-5" style="border-radius: 5px;">
        <div class="d-flex justify-content-between">
          <div>
            <h3 v-if="!long">{{detailItem.subject}}</h3>
            <div class="row mb-2">
              <span class="fs-6 col-12 col-md-3">{{$t('mail.of')}} : </span>
              <span class="fs-5 col-12 col-md-10 col-lg-10">{{detailItem.from_name??'' + ' ' + detailItem.from}}</span>
            </div>
            <div class="d-flex" v-if="detailItem.to?.length > 0">
              <span class="fs-6 col-12 col-md-3">{{$t('mail.to')}} : </span>
              <span class="fs-5 col-12 col-md-10 col-lg-10 d-flex">
                <span class="badge badge-light-primary me-2" v-for="(to, index) in detailItem?.to.split(',')" :key="index">{{ to }}</span>
              </span>
            </div>
            <div class="d-flex">
              <span class="fs-6 col-12 col-md-3">{{$t('mail.date')}} : </span>
              <span class="fs-5 col-12 col-md-10 col-lg-10">{{$dateFormatterWithDay(detailItem.date, locale, true)}}</span>
            </div>
            <div class="d-flex" v-if="detailItem?.cc?.length > 0">
              <span class="fs-6 col-12 col-md-3">{{$t('mail.cc')}} : </span>
              <span class="fs-5 col-12 col-md-10 col-lg-10">
                <span class="badge badge-light-primary me-2" v-for="(cc, index) in detailItem?.cc" :key="index">{{ cc.full ? cc.full : cc.mail }}</span>
              </span>
            </div>
            <div class="d-flex" v-if="detailItem?.bcc?.length > 0">
              <span class="fs-6 col-12 col-md-3">CCi : </span>
              <span class="fs-5 col-12 col-md-10 col-lg-10">
                <span class="badge badge-light-primary me-2" v-for="(bcc, index) in detailItem?.bcc" :key="index">{{ bcc.full ? bcc.full : bcc.mail }}</span>
              </span>
            </div>
          </div>
          
        
        </div>
      </div>

      <div class="row">
        <div :class="attachFiles.length > 0 ? 'col-12 col-md-8 col-lg-8' : 'col-12'">
          <div class="card border_style">
            <div v-if="detailItem.body">
              <iframe :srcdoc="buildMailHtml(detailItem.body)" style="width: 100%; border: none; height: 400px !important;"></iframe>
            </div>
          </div>
        </div>
        <div :class="attachFiles.length > 0 ? 'col-12 col-md-4 col-lg-4' : 'col-12'" v-if="attachFiles.length > 0">
          <div class="card border_style">
            <div class="card-header">
              <div class="d-flex align-items-center">
                <h2>{{$t('pipelines.attach_files')}}</h2>
                <span class="badge badge-light-warning fs-2 mb-2 ms-3">{{attachFiles.length}}</span>
              </div>
              <div class="card-toolbar">
                <div class="d-flex align-items-center" style="color: #303D4E; cursor: pointer;" :style="disabled ? 'pointer-events: none; opacity: 0.5;' : ''"  @click="downloadAllFile">
                  <i class="fas fa-download fs-2" style="color: #303D4E; cursor: pointer;" :title="$t('button.download')"></i>
                </div>
              </div>
            </div>
            <div class="card-body p-5">
              <div style="overflow-y: auto; max-height: 280px !important;">
                <FileUploaded modalType="modal-fullscreen" :remove="false" :attach-files="attachFiles"/>
              </div>
            </div>
          </div>
        </div>
      </div> 
    </div>
   <div class="text-center" v-else>
      <Img filename="empty.png" alt="" class="mw-100 h-150px" />
      <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_mail_found') }}</div>
    </div>
</template>

<script setup>
import {computed, defineEmits, onMounted, ref, watch} from "vue";
import {$dateFormatterWithDay} from "@/mixins/Helpers";
import {useStore} from "vuex";
import {useLocales} from "@/composables/locales";
import FileUploaded from "@/components/FileUploaded";
import Img from "@/components/Img";
import {useRoute} from "vue-router";
import {useSwal} from "@/composables/useSwal";
import { useI18n } from 'vue-i18n'

const route =  useRoute()
const {showSwal} = useSwal()
const { t } = useI18n({ useScope: 'global' })

const emits = defineEmits(['transfer'])
const {locale} = useLocales()
const store = useStore()


const props = defineProps({
  detailItem: {
    type: Object,
    default: {}
  },
  user: {
    type: Object,
    default: {}
  },
  large: {
    type: Boolean,
    default: true
  },
  schedule: {
    type: Boolean,
    default: false
  }
})


const long = ref(props.large)
const disabled = ref(false)

const folder = computed(() => decodeURIComponent(decodeURIComponent(route.query.tab)))

const attachFiles = computed(() => {
  const value = props.detailItem.attachments
  return value
      ? value.map((item, index) => ({
        name: item.name,
        url: item.url,
        type: item.content_type,
        id: index + 1,
      }))
      : []
})


watch(() => props.large, (value) => {
  long.value = value
});


function buildMailHtml(htmlContent) {
  return `
    <!DOCTYPE html>
    <html>
      <head>
        <style>
          html, body {
            margin: 0;
            padding: 1rem;
            font-family: sans-serif;
          }

          figure.image {
            display: inline-block;
            max-width: 100%;
          }

          figure.image img {
            width: 100%;
            height: auto;
            display: block;
          }

          figure.image-style-align-right {
            float: right;
            margin-left: 1rem;
            margin-bottom: 1rem;
          }

          figure.image-style-align-left {
            float: left;
            margin-right: 1rem;
            margin-bottom: 1rem;
          }

          figure.image-style-align-center {
            margin: 0 auto;
            display: table;
          }
        </style>
      </head>
      <body>${htmlContent}</body>
    </html>
  `;
}

function downloadAllFile() {
  let data = {
    folder_path: props.detailItem.folder,
    message_uid: props.detailItem.id
  }
  showSwal(
      '',
      t('mail.swal.download_all'),
      'info',
      "rgba(0, 114, 206, 1)"
    ).then( async (result) => {
      if (result.value) {
        disabled.value = true
        store.dispatch('mails/downloadAllFile', data)
          .then(res => {
            const blob = new Blob([res.data], { type: res.headers['content-type'] || 'application/zip' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            let filename = props.detailItem?.subject + '.zip'
            link.setAttribute('download', filename);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            window.toastr['success'](t('notification.download_successfully'))
          }).finally(() => disabled.value = false)
      }
  });
}

onMounted(() => {
  window.scrollTo(0, document.body.scrollHeight);
})
</script>

<style scoped>
  .spinner-overlay {
    background-color: rgba(255, 255, 255, 0.3);
    z-index: 999;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .spinner {
    border: 6px solid #f3f3f3;
    border-top: 5px solid var(--bs-primary);
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 2s linear infinite;
    margin-left: 48%;
    margin-top: 5%;
    margin-bottom: 10px;
  }
  .border_style {
    border: 2px solid var(--bs-light)
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
</style>